import { useQuery } from "@tanstack/react-query";
import { userAPI } from "../services/api";
import { useAuth } from "../contexts/AuthContext";

/** Server filter defaults for Following tab when URL has no filters. */
export const FILTER_PREFERENCES_QUERY_KEY = ["filterPreferences"];

export const useFilterPreferencesQuery = (urlHasFilters) => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: FILTER_PREFERENCES_QUERY_KEY,
    queryFn: async () => {
      const res = await userAPI.getFilterPreferences();
      return res.data?.filterPreferences ?? null;
    },
    enabled: isAuthenticated && !urlHasFilters,
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
